module.exports = __webpack_public_path__ + "static/img/twin-highway-2.a7b5c9c0.png";